import { toLower } from 'lodash';

import { ITaxonomyPath } from 'taxonomy/types';

export const TaxonomyHelper = {
  getLastLevelTaxonomy: (taxonomyPath: ITaxonomyPath[]) => {
    if (!taxonomyPath || !taxonomyPath.length) {
      return null;
    }

    return [...taxonomyPath].pop();
  },

  getTaxonomyPathNames: (taxonomyPath: ITaxonomyPath[], lowerCase = false) => {
    if (!taxonomyPath || taxonomyPath.length === 0) {
      return [];
    }

    return taxonomyPath
      .filter((path: ITaxonomyPath) => path.level > 0)
      .map((path: ITaxonomyPath) => (lowerCase ? toLower(path.name) : path.name));
  },
};
